import { render, staticRenderFns } from "./noLogin_recordedInfo.vue?vue&type=template&id=4bdb2120&scoped=true"
import script from "./noLogin_recordedInfo.vue?vue&type=script&lang=js"
export * from "./noLogin_recordedInfo.vue?vue&type=script&lang=js"
import style0 from "./noLogin_recordedInfo.vue?vue&type=style&index=0&id=4bdb2120&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb2120",
  null
  
)

export default component.exports